module.exports = __webpack_public_path__ + "static/media/benzema-modal.e43ddb79.png";